import contentReducer from './reducer';

export default contentReducer;



// WEBPACK FOOTER //
// ./src/store/content/index.js